<div  id="preloader">
    <div class="preloader_icon"></div>
</div>